import { Box, Divider } from "@mui/material";
import { POSTHOG_EVENTS } from "../../../../constants/PostHogEvents";
import usePostHog from "../../../../hooks/usePostHog";
import CopyToClipboardButton from "../../CopyToClipboardButton/CopyToClipboardButton";
import styles from "../ApiReferenceDialog.module.scss";
import CodeExamplesDropdown, { ExampleType } from "../CodeExamplesDropdown/CodeExamplesDropdown";
import LanguagesDropdown, { Language } from "../LanguagesDropdown/LanguagesDropdown";

interface ApiReferenceControlsSectionProps {
	selectedLanguage: Language;
	setSelectedLanguage: (language: Language) => void;
	selectedExample: ExampleType;
	setSelectedExample: (example: ExampleType) => void;
	code: string;
}

const ApiReferenceControlsSection = ({
	selectedLanguage,
	setSelectedLanguage,
	selectedExample,
	setSelectedExample,
	code,
}: ApiReferenceControlsSectionProps) => {
	const { trackEvent } = usePostHog();

	const handleCodeCopied = () => {
		trackEvent(POSTHOG_EVENTS.API_REFERENCE_CODE_COPIED, {
			language: selectedLanguage,
			example: selectedExample,
			codeLength: code.length,
		});
	};

	return (
		<>
			<Box className={styles.codeHeader}>
				<LanguagesDropdown selectedLanguage={selectedLanguage} setSelectedLanguage={setSelectedLanguage} />
				<CopyToClipboardButton
					textToCopy={code}
					className={styles.copyButton}
					tooltipText="Copy code"
					afterCopyAction={handleCodeCopied}
				/>
			</Box>
			<Divider className={styles.divider} />
			<CodeExamplesDropdown selectedExample={selectedExample} setSelectedExample={setSelectedExample} />
		</>
	);
};

export default ApiReferenceControlsSection;
